// extracted by mini-css-extract-plugin
export default {"dates_container":"ReportByType_dates_container__loE4t"};